export default __webpack_public_path__ + "static/media/isco_updated.f2d1d579.svg";